<template>
	<modal ref="modal" size="modal-lg">
		<template #title>{{action.toUpperCase()}} SAM TABLE CONTENT</template>
		<template #body>
			<div class="form-floating mb-4">
				<select v-model="form.category" id="category" name="category" class="form-select" :class="{'disabled':form.is_boss==1}" :disabled="form.is_boss==1">
					<!-- <option value="1">1 - BOSS (Bo's Strategic Stock)</option> -->
					<option value="2">2 - Stocks with Bigger Cash Dividends</option>
					<option value="3">3 - Mature Stocks</option>
					<option value="4">4 - Young Growth Stocks</option>
					<option value="5">5 - REIT's</option>
					<option value="6">6 - Equity Funds</option>
					<option value="7">7 - Bonds</option>
				</select>
				<label class="form-label" for="category">Category</label>
			</div>
			<div class="form-floating mb-4">
				<input type="text" v-model="form.stock" id="stock" name="stock" class="form-control" placeholder="Stock" :readonly="action=='update'" />
				<label class="form-label" for="stock">Stock</label>
			</div>
			<div class="form-floating mb-4">
				<input type="text" v-model="form.stock_name" id="stock_name" name="stock_name" class="form-control" placeholder="Name" />
				<label class="form-label" for="stock_name">Name</label>
			</div>
			<div class="form-floating mb-4">
				<input type="text" v-model="form.tradeprice" id="tradeprice" name="tradeprice" class="form-control" placeholder="Trade Price" />
				<label class="form-label" for="tradeprice">Trade Price</label>
			</div>
			<div class="form-floating mb-4">
				<input type="text" v-model="form.buybelowprice" id="buybelowprice" name="buybelowprice" class="form-control" placeholder="Buy Below Price" />
				<label class="form-label" for="buybelowprice">Buy Below Price</label>
			</div>
			<div class="form-floating mb-4">
				<input type="text" v-model="form.targetprice" id="targetprice" name="targetprice" class="form-control" placeholder="Target Price" />
				<label class="form-label" for="targetprice">Target Price</label>
			</div>
			<div class="form-floating mb-4">
				<input type="text" v-model="form.maxperc" id="maxperc" name="maxperc" class="form-control" placeholder="Max Percent" />
				<label class="form-label" for="maxperc">Max Percent</label>
			</div>
			<div class="form-floating mb-4">
				<input type="text" v-model="form.dividend_yield_25e" id="dividend_yield_25e" name="dividend_yield_25e" class="form-control" placeholder="Dividend Yield 25E" />
				<label class="form-label" for="dividend_yield_25e">Dividend Yield 25E</label>
			</div>
			<div class="form-floating mb-4">
				<select v-model="form.actiontotake" id="actiontotake" name="actiontotake" class="form-select">
					<option value="Continue Buying">Continue Buying</option>
					<option value="Stop Buying">Stop Buying</option>
					<option value="Sell">Sell</option>
					<option value="Hold">Hold</option>
				</select>
				<label class="form-label" for="actiontotake">Action to Take</label>
			</div>
			<div class="form-group mb-4">
				<label class="form-label" for="is_boss">Boss</label>
				<div class="mt-2">
					<div class="form-check form-check-inline">
						<input
							v-model="form.is_boss"
							id="is_boss_on"
							name="is_boss"
							class="form-check-input"
							type="radio"
							value="1"
						/>
						<label class="form-check-label bg-alt-primary" for="ON">YES</label>
					</div>
					<div class="form-check form-check-inline">
						<input
							v-model="form.is_boss"
							id="is_boss_off"
							name="is_boss"
							class="form-check-input"
							type="radio"
							value="0"
						/>
						<label class="form-check-label bg-alt-primary" for="OFF">NO</label>
					</div>
				</div>
			</div>
			<div v-if="form.is_boss==1" class="row">
				<div class="col-6">
					<div class="form-floating mb-4">
						<select v-model="form.boss_month" id="boss_month" name="boss_month" class="form-select">
							<option v-for="mo in boss_months" :value="mo">{{mo}}</option>
						</select>
						<label class="form-label" for="boss_month">BOSS MONTH</label>
					</div>
				</div>
				<div class="col-6">
					<div class="form-floating mb-4">
						<select v-model="form.boss_year" id="boss_year" name="boss_year" class="form-select">
							<option v-for="yr in boss_years" :value="yr">{{yr}}</option>
						</select>
						<label class="form-label" for="boss_year">BOSS YEAR</label>
					</div>
				</div>
			</div>
			<div class="form-group mb-4">
				<label class="form-label" for="is_boss">Include in SAM?</label>
				<div class="mt-2">
					<div class="form-check form-check-inline">
						<input
							v-model="form.is_active"
							id="is_active_on"
							name="is_active"
							class="form-check-input"
							type="radio"
							value="1"
						/>
						<label class="form-check-label bg-alt-primary" for="ON">YES</label>
					</div>
					<div class="form-check form-check-inline">
						<input
							v-model="form.is_active"
							id="is_active_off"
							name="is_active"
							class="form-check-input"
							type="radio"
							value="0"
						/>
						<label class="form-check-label bg-alt-primary" for="OFF">NO</label>
					</div>
				</div>
			</div>

			<div v-if="action=='update' && setData.stock_history.length>0" class="form-group mb-4 border-top pt-3">
				<p class="m-0 fw-bold">HISTORY</p>
				<table class="table">
					<thead>
						<tr>
							<th class="fs-xs">Trade Price</th>
							<th class="fs-xs">Buy Below Price</th>
							<th class="fs-xs">Target Price</th>
							<th class="fs-xs">Max Percent</th>
							<th class="fs-xs">Dividend Yield 25E Percent</th>
							<th class="fs-xs">Last Trade Date</th>
							<th class="fs-xs text-end">:::</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(stock,index) in setData.stock_history" :class="{'bg-info-light':selected_id==stock.stock_history_id}">
							<td>{{stock.tradeprice}}</td>
							<td>{{stock.buybelowprice}}</td>
							<td>{{stock.targetprice}}</td>
							<td>{{stock.maxperc}}</td>
							<td>{{stock.dividend_yield_25e}}</td>
							<td>{{stock.lasttradedate}}</td>
							<td class="text-end">
								<button type="button" @click="deleteHistory(index)" class="btn btn-xs btn-outline-danger"><i class="fa fa-trash"></i></button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
				
		</template>
		<template #footer>
			<button 
				@click="actionContent"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing || !form.isDirty"
			>
				<span v-if="!form.processing"><i class="fa fa-save me-2"></i><span v-if="action=='add'">Add</span><span v-else>Update</span> Content</span>
				<span v-else>
					<div class="spinner-border spinner-border-sm text-dark" role="status" >
						<span class="sr-only mr-1">Please wait...</span>
					</div>
					<span class="mx-2">Please wait...</span>
				</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>

	<modal ref="modalDeleteHistory">
		<template #title>DELETE CONFIRMATION</template>
		<template #body>
			<p>Are you sure, want to delete this history?</p>
		</template>
		<template #footer>
			<button type="button" @click="confirmDeleteHistory()" class="btn btn-sm btn-outline-success">
				<div
					v-if="formDel.processing"
					class="spinner-border spinner-border-sm text-white me-1"
					role="status"
				>
					<span class="sr-only">Loading...</span>
				</div>
				<i v-else class="fa fa-check me-1"></i>
			YES</button>
			<button type="button" @click="cancelDeleteHistory()" class="btn btn-sm btn-outline-danger"><i class="fa fa-times me-1"></i>NO</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref, reactive } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	props: {
		
	},
	emits: ['updateAction'],
	setup(props,context) {
		const modal = ref(null);

		const modalDeleteHistory = ref(null);

		const toggleModal = () => {
			modal.value.toggleModal();
		}
		
		const action = ref('add');
		const selected_id = ref(0);

		const boss_months = ref(
			["JANUARY","FEBRUARY","MARCH","APRIL","MAY","JUNE","JULY","AUGUST","SEPTEMBER","OCTOBER","NOVEMBER","DECEMBER"]
		);
		const boss_years = ref(
			[new Date().getFullYear(),(new Date().getFullYear())+1]
		);

		const setData = reactive({});

		const form = useForm({
			counter 		: 0,
			category 		: '',
			stock 			: '',
			stock_name 		: '',
			tradeprice 		: 0,
			buybelowprice 	: 0,
			targetprice 	: 0,
			maxperc 		: 0,
			dividend_yield_25e: 0,
			actiontotake 	: '',
			is_boss 		: 0,
			boss_month 		: null,
			boss_year 		: null,
			is_active 		: 1,
		})

		const formDel = useForm({});

		const deleteHistory = (_index)=>{
			selected_id.value = setData.stock_history[_index].stock_history_id;
			modalDeleteHistory.value.toggleModal();
		}

		const cancelDeleteHistory = ()=>{
			selected_id.value = 0;
			modalDeleteHistory.value.toggleModal();
		}

		const actionContent = ()=>{

			if(action.value=='add')
			{
				addContent();
			}else
			{
				updateContent();	
			}

		}

		const addContent = () => {
			form.post(route('admin.post.sam-table'), {
				preserveState: true,
				preserveScroll: true,
				only:['stocks,search,api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const updateContent = () => {
			form.put('sam-table/'+form.counter, {
				preserveState: true,
				preserveScroll: true,
				only:['stocks,search,api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const confirmDeleteHistory = ()=>{
			context.emit('updateAction', "delete");
			formDel.delete('sam-table/stock-history/'+selected_id.value, {
				preserveState: true,
				preserveScroll: true,
				only:['stocks,search,api_response'],
				onSuccess: () => {
					cancelDeleteHistory();
					toggleModal();
				},
			})
		}

		const setSamTableContent = (_action,data)=>{
								
								form.reset();

								action.value = _action;

								Object.assign(setData,data);
								;
								if(_action=='update')
								{
									form.counter 			= data.counter;
									form.category 			= data.category;
									form.stock 				= data.stock;
									form.stock_name 		= data.stock_name;
									form.tradeprice 		= data.tradeprice;
									form.buybelowprice 		= data.buybelowprice;
									form.targetprice 		= data.targetprice;
									form.maxperc 			= data.maxperc;
									form.dividend_yield_25e = data.dividend_yield_25e;
									form.actiontotake 		= data.actiontotake;
									form.is_boss 			= data.is_boss;
									form.boss_month 		= data.boss_month;
									form.boss_year 			= data.boss_year;
									form.is_active 			= data.is_active;
								}
								
							}


		return {
			setData,
			form,
			formDel,
			modal,
			toggleModal,
			modalDeleteHistory,
			action,
			boss_months,
			boss_years,
			selected_id,
			setSamTableContent,
			deleteHistory,
			cancelDeleteHistory,
			actionContent,
			addContent,
			updateContent,
			confirmDeleteHistory,
		}
	},
}
</script>
